import React, { memo, useState, Fragment } from 'react';
import { LoanService } from '../../services';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Delete from '@material-ui/icons/Delete';
import ConfirmationModal from '../../components/ConfirmationModal'
import { formatDate, getCurrentDateFormatted } from '../../utils/formatters';
import { useRole } from '../../contexts/RolesContext';
import { useError } from '../../contexts/ErrorContext';


const DeleteFundingRequestsButtons = ({selectedRowIndices, potentialDeletions, date}) => {
  const [showDeleteFundingRequestsConfirmation, setShowDeleteFundingRequestsConfirmation] = useState(false);
  const { hasRole, isAdmin } = useRole();
  const { showError } = useError();

  const toggleDeleteFundingRequestsConfirmation = () => setShowDeleteFundingRequestsConfirmation(!showDeleteFundingRequestsConfirmation);

  const handleDeleteClick = () => {
    toggleDeleteFundingRequestsConfirmation();
    LoanService.deleteFundingRequests(selectedRowIndices.map(rowId => {
      return potentialDeletions[rowId].id;
    })).then(response => {
      // !FIXME: Do this better!
      window.location.reload();
    }).catch(showError);
  }

  return (formatDate(date) === getCurrentDateFormatted() && (isAdmin()  && !hasRole('cs')) ? (
    <>
    <Fragment>
        <Tooltip title={"Delete Funding Requests"}>
          <IconButton onClick={toggleDeleteFundingRequestsConfirmation}> 
            <Delete />
          </IconButton>
        </Tooltip>
    </Fragment>
    <ConfirmationModal title="Confirm" message="Are you sure you want to delete these funding requests" onConfirm={handleDeleteClick} onCancel={toggleDeleteFundingRequestsConfirmation} showConfirmationBox={showDeleteFundingRequestsConfirmation}/>
    </>
  ) : null);
}

export default memo(DeleteFundingRequestsButtons);